import { CommonModule } from '@angular/common';
import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'app-select-multi',
	templateUrl: './select-multi.component.html',
	styleUrls: ['./select-multi.component.css'],
	imports: [
		CommonModule,
		MatAutocompleteModule,
		MatFormFieldModule,
		MatChipsModule,
		MatCheckboxModule,
		MatInputModule,
	],
	standalone: true,
})
export class SelectMultiComponent implements OnInit, OnChanges {
	@Input() labelKey = 'name';
	@Input() displayingLabel: string = null;
	@Input() placeholder = '';
	@Input() options: any[] = [];
	@Input() selected: any[] = [];
	@Input() disabled = false;
	@Output() selectedChange = new EventEmitter();
	@Output() clicked = new EventEmitter();
	@Output() blured = new EventEmitter();
	@ViewChild('optionsInput', { static: false })
	optionsInput: ElementRef<HTMLInputElement>;

	protected optionsFiltered: any[] = [];
	protected searchValue = '';
	protected opened = false;

	ngOnInit(): void {
		this.optionsFiltered = this.options;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!this.options || !this.selected) {
			return;
		}
		if (changes.selected && changes.selected.previousValue != changes.selected.currentValue) {
			this.checkSelected();
		}
		if (changes.options && changes.options.previousValue != changes.options.currentValue) {
			this.optionsFiltered = this.options;
		}
	}

	private checkSelected(): void {
		for (const index in this.selected) {
			if (this.selected[index].name) {
				return;
			}
			const foundObject: any = this.options.find((obj) => obj.id == this.selected[index].id);
			if (!foundObject) {
				return;
			}
			this.selected[index] = foundObject;
		}
	}

	protected filter(): void {
		const search = this.optionsInput.nativeElement.value.toLocaleLowerCase();
		this.optionsFiltered = this.options.filter((option) =>
			option[this.labelKey].toLocaleLowerCase().includes(search),
		);
	}

	protected remove(item: any): void {
		const index = this.selected.findIndex((obj) => obj == item);
		if (index === -1) {
			return;
		}
		this.selected.splice(index, 1);
		this.selectedChange.emit(this.selected);
	}

	protected optionClicked(event: Event, item: any): void {
		event.stopPropagation();
		this.toggleSelection(item);
		this.optionsInput.nativeElement.focus();
	}

	protected toggleSelection(item: any): void {
		const index = this.selected.findIndex((objFind) => objFind == item);
		if (index === -1) {
			this.selected.push(item);
		} else {
			this.selected.splice(index, 1);
		}
		this.selectedChange.emit(this.selected);
	}

	protected clear(): void {
		this.selected.splice(0, this.selected.length);
		this.selectedChange.emit(this.selected);
	}

	protected selectAll(): void {
		this.optionsFiltered.forEach((item) => {
			const index = this.selected.findIndex((objFind) => objFind == item);
			if (index === -1) {
				this.selected.push(item);
			} else {
				this.selected.splice(index, 1);
			}
		});
		this.selectedChange.emit(this.selected);
	}

	protected onClick(item: any): void {
		if (this.disabled) {
			return;
		}
		this.clicked.emit(item);
	}

	protected autocompleteToggle(state: boolean): void {
		this.opened = state;
		if (!this.opened) {
			this.blured.emit();
		}
	}
}
